import React, { useEffect, useState } from 'react';
import './strukturorganisasi.scss';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import FooterId from '../../../footer/FooterId';
import FooterEn from '../../../footer/FooterEn';
import 'aos/dist/aos.css';

const StrukturOrganisasi = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isIdPath = location.pathname.startsWith('/en');
  const [activeButton, setActiveButton] = useState('');

  useEffect(() => {
    // Set activeButton based on the final part of the URL path
    const pathArray = location.pathname.split('/');
    const finalPath = pathArray[pathArray.length - 1]; // Get the final path segment
    setActiveButton(finalPath);
  }, [location.pathname]);

  const handleButtonClick = (componentName) => {
    setActiveButton(componentName);
    navigate(`/en/aboutus/organization-structure/${componentName.toLowerCase()}`);

    // Scroll only if current scroll position is less than 400px
    if (window.scrollY < 500) {
      window.scrollTo({
        top: 500,
        behavior: 'smooth',
      });
    } else {
      // Scroll to top if current scroll position is above 400px
      window.scrollTo({
        top: 500,
        behavior: 'smooth',
      });
    }
  };

  return (
    <>
      <div className="mainContainerOrganisasi">
        <div className="menuStrukturOrganisasi">
          <div className={`btnOrganisasi ${activeButton === 'board-of-commissioners' ? 'clicked' : ''}`} onClick={() => handleButtonClick('board-of-commissioners')}>
            Board of Commissioners
          </div>
          <div className={`btnOrganisasi ${activeButton === 'board-of-director' ? 'clicked' : ''}`} onClick={() => handleButtonClick('board-of-director')}>
            Board of Directors
          </div>
          {/* Uncomment the following divs to add more buttons */}
          <div className={`btnOrganisasi ${activeButton === 'corporate-secretary' ? 'clicked' : ''}`} onClick={() => handleButtonClick('corporate-secretary')}>
            Corporate Secretary
          </div>
          {/* <div className={`btnOrganisasi ${activeButton === 'audit-committee' ? 'clicked' : ''}`} onClick={() => handleButtonClick('audit-committee')}>
            Audit Committee
          </div>
          <div className={`btnOrganisasi ${activeButton === 'nomination-committee' ? 'clicked' : ''}`} onClick={() => handleButtonClick('nomination-committee')}>
            Nomination and Remuneration Committee
          </div> */}
          {/* <div className={`btnOrganisasi ${activeButton === 'evaluation-committee' ? 'clicked' : ''}`} onClick={() => handleButtonClick('evaluation-committee')}>
            Evaluation Committee
          </div> */}
        </div>
        <div className="outletOrganization ">
          <Outlet />
        </div>
      </div>
      <div className="footer">{isIdPath ? <FooterEn /> : <FooterId />}</div>
    </>
  );
};

export default StrukturOrganisasi;
